import React, { useState } from 'react'
import { makeStyles } from '@material-ui/core/styles'
import Button from '@material-ui/core/Button'
import Dialog from '@material-ui/core/Dialog'
import DialogActions from '@material-ui/core/DialogActions'
import DialogContent from '@material-ui/core/DialogContent'
import DialogTitle from '@material-ui/core/DialogTitle'
import Paper from '@material-ui/core/Paper'
import Draggable from 'react-draggable'
import styled from 'styled-components'
import TextField from '@material-ui/core/TextField'
import Table from '@material-ui/core/Table'
import TableBody from '@material-ui/core/TableBody'
import TableCell from '@material-ui/core/TableCell'
import TableContainer from '@material-ui/core/TableContainer'
import TableHead from '@material-ui/core/TableHead'
import TableRow from '@material-ui/core/TableRow'
import { CircularProgress } from '@material-ui/core'

import { ThemeProvider } from '@material-ui/styles'
import { createMuiTheme } from '@material-ui/core/styles'
import { create } from 'jss'
import { StylesProvider, jssPreset } from '@material-ui/core/styles'
import rtl from 'jss-rtl'

const jss = create({ plugins: [...jssPreset().plugins, rtl()] })

const theme = createMuiTheme({
	direction: 'rtl',
	typography: {
		fontFamily: ['Cairo', 'Arial', 'sans-serif'].join(','),
	},
})

const Root = styled.div`
	display: flex;
	flex-direction: column;
	align-items: flex-start;
	justify-content: baseline;
	width: 100%;
`

const useStyles = makeStyles((theme) => ({
	textField: {
		backgroundColor: '#fff',
		width: '120px',
	},
	tableCell: {
		padding: '8px',
	},
	headerCell: {
		backgroundColor: '#007AC4',
		color: '#fff',
		fontWeight: 'bold',
		textAlign: 'center',
	},
	labelCell: {
		backgroundColor: '#f5f5f5',
		fontWeight: 'bold',
		textAlign: 'right',
		minWidth: '180px',
	},
}))

function PaperComponent(props) {
	return (
		<Draggable
			handle="#draggable-dialog-title"
			cancel={'[class*="MuiDialogContent-root"]'}
		>
			<Paper {...props} />
		</Draggable>
	)
}

export default function ChangeWeightsModal(props) {
	const classes = useStyles()
	const { vehicleClass, open, closeModal, onSubmit, isRequesting } = props

	const isKabsatClass = vehicleClass?.name === 'كابسات'

	// State for regular classes
	const [regularFields, setRegularFields] = useState({
		weight_thatee: '',
		weight_moajar: '',
		ration_thatee: '',
		ration_moajar: '',
		share_thatee: '',
		share_moajar: '',
	})

	// State for كابسات class (8 combinations: 3 sizes + 1 unspecified × 2 types)
	const [kabsatFields, setKabsatFields] = useState({
		weight_kabsat_small_thatee: '',
		weight_kabsat_small_moajar: '',
		weight_kabsat_medium_thatee: '',
		weight_kabsat_medium_moajar: '',
		weight_kabsat_large_thatee: '',
		weight_kabsat_large_moajar: '',
		weight_kabsat_unspecified_thatee: '',
		weight_kabsat_unspecified_moajar: '',
		ration_kabsat_small_thatee: '',
		ration_kabsat_small_moajar: '',
		ration_kabsat_medium_thatee: '',
		ration_kabsat_medium_moajar: '',
		ration_kabsat_large_thatee: '',
		ration_kabsat_large_moajar: '',
		ration_kabsat_unspecified_thatee: '',
		ration_kabsat_unspecified_moajar: '',
		share_kabsat_small_thatee: '',
		share_kabsat_small_moajar: '',
		share_kabsat_medium_thatee: '',
		share_kabsat_medium_moajar: '',
		share_kabsat_large_thatee: '',
		share_kabsat_large_moajar: '',
		share_kabsat_unspecified_thatee: '',
		share_kabsat_unspecified_moajar: '',
	})

	const handleRegularChange = (e) => {
		setRegularFields({
			...regularFields,
			[e.target.name]: e.target.value,
		})
	}

	const handleKabsatChange = (e) => {
		setKabsatFields({
			...kabsatFields,
			[e.target.name]: e.target.value,
		})
	}

	const handleSubmit = () => {
		const data = isKabsatClass ? kabsatFields : regularFields

		// Check if at least one field has a value
		const hasValue = Object.values(data).some(val => val !== '' && val !== null)
		if (!hasValue) {
			alert('يجب ملء حقل واحد على الأقل')
			return
		}

		// Show confirmation dialog
		const confirmed = window.confirm('هل أنت متأكد من تحديث الاوزان وقيم الادامة والحصص لجميع المركبات المرتبطة بهذا الصنف؟')
		if (!confirmed) {
			return
		}

		// Filter out empty values
		const filteredData = {}
		Object.keys(data).forEach(key => {
			if (data[key] !== '' && data[key] !== null) {
				filteredData[key] = parseFloat(data[key])
			}
		})

		onSubmit(vehicleClass.id, filteredData)
	}

	const handleEnteredEvent = (e) => {
		if (!isRequesting) {
			if (e.key === 'Enter') {
				handleSubmit()
			} else if (e.key === 'Escape') {
				closeModal()
			}
		}
	}

	const renderRegularClassForm = () => (
		<TableContainer component={Paper}>
			<Table size="small">
				<TableHead>
					<TableRow>
						<TableCell className={classes.headerCell}>النوع</TableCell>
						<TableCell className={classes.headerCell}>الوزن</TableCell>
						<TableCell className={classes.headerCell}>قيمة الادامة</TableCell>
						<TableCell className={classes.headerCell}>الحصة</TableCell>
					</TableRow>
				</TableHead>
				<TableBody>
					<TableRow>
						<TableCell className={classes.labelCell}>ذاتي</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="weight_thatee"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.weight_thatee}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="ration_thatee"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.ration_thatee}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="share_thatee"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.share_thatee}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
					</TableRow>
					<TableRow>
						<TableCell className={classes.labelCell}>مؤجر</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="weight_moajar"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.weight_moajar}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="ration_moajar"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.ration_moajar}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
						<TableCell className={classes.tableCell}>
							<TextField
								className={classes.textField}
								name="share_moajar"
								type="number"
								variant="outlined"
								size="small"
								value={regularFields.share_moajar}
								onChange={handleRegularChange}
								inputProps={{ step: "0.01", min: "0" }}
							/>
						</TableCell>
					</TableRow>
				</TableBody>
			</Table>
		</TableContainer>
	)

	const renderKabsatClassForm = () => {
		const rows = [
			{ label: 'كابسات صغيرة - ذاتي', weightField: 'weight_kabsat_small_thatee', rationField: 'ration_kabsat_small_thatee', shareField: 'share_kabsat_small_thatee' },
			{ label: 'كابسات صغيرة - مؤجر', weightField: 'weight_kabsat_small_moajar', rationField: 'ration_kabsat_small_moajar', shareField: 'share_kabsat_small_moajar' },
			{ label: 'كابسات متوسطة - ذاتي', weightField: 'weight_kabsat_medium_thatee', rationField: 'ration_kabsat_medium_thatee', shareField: 'share_kabsat_medium_thatee' },
			{ label: 'كابسات متوسطة - مؤجر', weightField: 'weight_kabsat_medium_moajar', rationField: 'ration_kabsat_medium_moajar', shareField: 'share_kabsat_medium_moajar' },
			{ label: 'كابسات كبيرة - ذاتي', weightField: 'weight_kabsat_large_thatee', rationField: 'ration_kabsat_large_thatee', shareField: 'share_kabsat_large_thatee' },
			{ label: 'كابسات كبيرة - مؤجر', weightField: 'weight_kabsat_large_moajar', rationField: 'ration_kabsat_large_moajar', shareField: 'share_kabsat_large_moajar' },
			{ label: 'كابسات (بدون تحديد حجم) - ذاتي', weightField: 'weight_kabsat_unspecified_thatee', rationField: 'ration_kabsat_unspecified_thatee', shareField: 'share_kabsat_unspecified_thatee' },
			{ label: 'كابسات (بدون تحديد حجم) - مؤجر', weightField: 'weight_kabsat_unspecified_moajar', rationField: 'ration_kabsat_unspecified_moajar', shareField: 'share_kabsat_unspecified_moajar' },
		]

		return (
			<TableContainer component={Paper}>
				<Table size="small">
					<TableHead>
						<TableRow>
							<TableCell className={classes.headerCell}>الحجم والنوع</TableCell>
							<TableCell className={classes.headerCell}>الوزن</TableCell>
							<TableCell className={classes.headerCell}>قيمة الادامة</TableCell>
							<TableCell className={classes.headerCell}>الحصة</TableCell>
						</TableRow>
					</TableHead>
					<TableBody>
						{rows.map((row, index) => (
							<TableRow key={index}>
								<TableCell className={classes.labelCell}>{row.label}</TableCell>
								<TableCell className={classes.tableCell}>
									<TextField
										className={classes.textField}
										name={row.weightField}
										type="number"
										variant="outlined"
										size="small"
										value={kabsatFields[row.weightField]}
										onChange={handleKabsatChange}
										inputProps={{ step: "0.01", min: "0" }}
									/>
								</TableCell>
								<TableCell className={classes.tableCell}>
									<TextField
										className={classes.textField}
										name={row.rationField}
										type="number"
										variant="outlined"
										size="small"
										value={kabsatFields[row.rationField]}
										onChange={handleKabsatChange}
										inputProps={{ step: "0.01", min: "0" }}
									/>
								</TableCell>
								<TableCell className={classes.tableCell}>
									<TextField
										className={classes.textField}
										name={row.shareField}
										type="number"
										variant="outlined"
										size="small"
										value={kabsatFields[row.shareField]}
										onChange={handleKabsatChange}
										inputProps={{ step: "0.01", min: "0" }}
									/>
								</TableCell>
							</TableRow>
						))}
					</TableBody>
				</Table>
			</TableContainer>
		)
	}

	return (
		<ThemeProvider theme={theme}>
			<StylesProvider jss={jss}>
				<Dialog
					fullWidth={true}
					maxWidth="md"
					disableBackdropClick={true}
					open={open}
					onClose={closeModal}
					PaperComponent={PaperComponent}
					aria-labelledby="draggable-dialog-title"
					onKeyDown={handleEnteredEvent}
				>
					<DialogTitle
						style={{
							backgroundColor: '#007AC4',
							color: '#fff',
							cursor: 'move',
						}}
						id="draggable-dialog-title"
					>
						تغيير الاوزان لجميع المركبات المرتبطة بهذا الصنف ({vehicleClass?.name})
					</DialogTitle>
					<DialogContent
						style={{
							backgroundColor: '#DEF3FF',
							paddingTop: '20px',
						}}
					>
						<Root>
							{isKabsatClass ? renderKabsatClassForm() : renderRegularClassForm()}
						</Root>
					</DialogContent>
					<DialogActions>
						<Button
							disabled={isRequesting}
							autoFocus
							onClick={closeModal}
							color="primary"
						>
							الغاء
						</Button>
						<Button
							disabled={isRequesting}
							onClick={handleSubmit}
							color="primary"
							variant="contained"
							style={{ backgroundColor: isRequesting ? '#ccc' : '#007AC4', color: '#fff' }}
						>
							{isRequesting ? <CircularProgress size={24} color="inherit" /> : 'حفظ'}
						</Button>
					</DialogActions>
				</Dialog>
			</StylesProvider>
		</ThemeProvider>
	)
}
